import { render } from "./AnalysisBrief.vue?vue&type=template&id=ae7f60d0&scoped=true&ts=true"
import script from "./AnalysisBrief.vue?vue&type=script&lang=ts"
export * from "./AnalysisBrief.vue?vue&type=script&lang=ts"

import "./AnalysisBrief.vue?vue&type=style&index=0&id=ae7f60d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7f60d0"]])

export default __exports__